module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/bookmark-864b58c71895e8c9d5becfd915ab6b02.svg";